import axios from 'axios'
import {
  BudgetLineItem,
  BudgetTransferLine,
  CashflowMonthlyLine,
  PcgContingencyHistoryPoint,
  VariationLineItem,
} from '../../modules/pcgreport/models'
import {VariationStatus} from '../../modules/variationassessments/models'

const API_URL = process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/Dashboard` : undefined

export type DashboardBudgetSummary = {
  contractSum: number
  adjustedBudget: number
  committed: number
  hasPcgReport: boolean
}

export type DashboardSubmittedVariation = {
  id: string
  variationNumber: string
  ageDays: number
  amount: number
}

export type DashboardVariationStatusSummary = {
  id: string
  label: string
  axisLabel: string
  count: number
  totalAmount: number
  color: string
  filterStatus?: VariationStatus
}

export type DashboardContingencySummary = {
  total: number
  committed: number
  remaining: number
  remainingPercent: number
  hasData: boolean
}

export type DashboardPcgReport = {
  meta: {
    id: string
    projectId: string
    dateOfIssue?: string | null
  }
  projectStartDate?: string | null
  programCompletionDate?: string | null
  constructionStartDate?: string | null
  constructionPracticalCompletionDate?: string | null
  budget: BudgetLineItem[]
  budgetTransfers: BudgetTransferLine[]
  variations: VariationLineItem[]
  constructionCashflowMonthly: CashflowMonthlyLine[]
  contingencyHistory: PcgContingencyHistoryPoint[]
}

export type DashboardOverview = {
  projectCompletionDate?: string | null
  budgetSummary: DashboardBudgetSummary
  submittedVariations: DashboardSubmittedVariation[]
  variationStatusSummaries: DashboardVariationStatusSummary[]
  contingencySummary: DashboardContingencySummary
  latestPcgReport?: DashboardPcgReport | null
}

export const getDashboardOverview = async (
  projectId: number | string
): Promise<DashboardOverview> => {
  if (!API_URL) {
    throw new Error('Dashboard API URL is not configured.')
  }

  const {data} = await axios.get<DashboardOverview>(`${API_URL}/${projectId}`)
  return data
}
